import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { verifyEmail } = useAuth();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("No verification token provided.");
      return;
    }
    setStatus("pending");
    verifyEmail(token)
      .then(() => {
        setStatus("success");
        setMessage("Your email has been verified! You can now log in.");
        setTimeout(() => navigate("/login"), 3000);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(
          err?.response?.data?.detail || err.message || "Verification failed."
        );
      });
  }, [searchParams, navigate, verifyEmail]);

  return (
    <div className="max-w-md mx-auto mt-24 p-6 border border-gray-300 bg-white rounded shadow text-center">
      <h2 className="text-xl font-bold mb-4">Verify Email</h2>
      {status === "pending" && (
        <div className="text-gray-600">Verifying...</div>
      )}
      {status === "success" && (
        <div className="text-green-700 font-semibold">{message}</div>
      )}
      {status === "error" && (
        <div className="text-red-700 font-semibold">{message}</div>
      )}
      {status === "success" && (
        <div className="mt-4 text-gray-600">Redirecting to login...</div>
      )}
    </div>
  );
};

export default VerifyEmailPage;
